/* eslint-disable */
import throwMethodNotImplementedError from '../../../../Errors/General/MethodNotImplemented.error';
import AnalyticsAdapter from '../Analytics.adapter';

/**
 * AnalyticsMemoryAdapter
 * @class AnalyticsMemoryAdapter
 * @implements {AnalyticsServiceAdapterContract}
 * @extends {AnalyticsAdapter}
 */
class AnalyticsMemoryAdapter extends AnalyticsAdapter {
  /**
   * The AnalyticsMemoryAdapter specific config
   * @type {AnalyticsMemoryAdapterConfig}
   * @memberof AnalyticsMemoryAdapter
   */
  _config;

  /**
   * Creates an instance of AnalyticsMemoryAdapter
   * @param {AnalyticsMemoryAdapterCreateDto} dto The params required to create an instance of `AnalyticsMemoryAdapter`
   * @memberof AnalyticsMemoryAdapter
   */
  constructor({ config }) {
    super();
    this._config = config;
  }

  /**
   * Add an Analytics script to the page
   * @returns {void} void
   * @memberof AnalyticsAdapter
   */
  addScript = () => {
    return throwMethodNotImplementedError(`addScript`);
  };

  /**
   * Track an event
   * @param {AnalyticsEvent} event The event to track
   * @returns {void} void
   * @memberof AnalyticsMemoryAdapter
   */
  track = (event) => {
    return throwMethodNotImplementedError(`track`);
  };
}

export default AnalyticsMemoryAdapter;
